import BundleCreationModel from '../../../../../core/models/distribution/BundleCreationModel';
import ContentLayoutComponent from '../../../../../layouts/content/component/content.layout.component';
import BundleVersionDAO from '../version/DAO/BundleVersionDAO';
import CreateBundleController from './bundle.create.controller';
export default class CreateBundleComponent {
	constructor() {
		this.template = require('./bundle.create.view.html');
		this.controller = CreateBundleController;
		this.bindings = {
			bundle: '<'
		};
	}
}

CreateBundleComponent.META = {
	name: 'createBundle',
	state: {
        isDistributionState: true,
        name: 'createBundle',
		url: '/createBundle',
		params: {release_bundle: null, release_bundle_version: null, prevUrl: null},
		template: '<create-bundle bundle="$resolve.bundle"></create-bundle>',
		parent: ContentLayoutComponent.META.state,
		resolve: {
			bundleVersionDAO: BundleVersionDAO.META.name,
			bundle: async (bundleVersionDAO, $stateParams, $state, $q) => {
				let deferred = $q.defer();
                const canCreateReleaseBundle = window.store.getters['common/context/GET_CAN_CREATE_BUNDLE'];
                if(!canCreateReleaseBundle){
                    const routes = window.store.getters["distribution/GET_ROUTE_CONSTANTS"];
                    window.$vueRouter.push({
                        name: routes.DISTRIBUTION_MAIN,
                        params: { activeTab: 'source' }
                    });
                    deferred.reject();
                    return deferred.promise;
                }
                let bundleData = {};
                const { release_bundle, release_bundle_version } = $stateParams;
                if (release_bundle) {
                    bundleData = { name: release_bundle };
                    if(release_bundle_version) {
                        try {
                            const response = await bundleVersionDAO.Resource.getReleaseBundleVersion($stateParams).$promise;
                            bundleData = Object.assign({}, response, {
                                name: release_bundle,
                                version: `Copy_of_${release_bundle_version}`
                            });
                        } catch ({ response }) {
                            if (response.status === 404 || response.status === 403) {
                                window.$vueRouter.push({ name:'404' });
                                deferred.reject();
                                return deferred.promise;
                            }
                        }
                    }
                }
                deferred.resolve(new BundleCreationModel(bundleData));
				return deferred.promise;
			}
		}
	}
};



// WEBPACK FOOTER //
// ./modules/distribution/modules/distribution/components/bundle/create/bundle.create.component.js